<template>
  <b-card>

    <b-form-row class="filter-container mb-2 d-flex justify-content-between align-items-center flex-nowrap">
      <span class="ml-1 mr-2">ფილტრები: </span>
      <b-form-group label-for="account-type"
                    class="mr-2 mb-0"
                    v-slot="{ ariaDescribedby }">
        <b-input-group>
          <b-form-select id="account-type"
                         v-model="filteringOptions.selectedType"
                         :options="typeOptions"
                         :aria-describedby="ariaDescribedby"
                         class="w-75">
            <template #first>
              <b-form-select-option :value="null" disabled>მაჩვენე მხოლოდ</b-form-select-option>
            </template>
          </b-form-select>
        </b-input-group>
      </b-form-group>

      <b-form-group label-for="group-by"
                    class="mr-2 mb-0"
                    v-slot="{ ariaDescribedby }">
        <b-input-group>
          <b-form-select id="group-by"
                         v-model="filteringOptions.selectedGroupBy"
                         :options="groupByOptions"
                         :aria-describedby="ariaDescribedby"
                         class="w-75">
            <template #first>
              <b-form-select-option :value="null" disabled>დაჯგუფება</b-form-select-option>
            </template>
          </b-form-select>
        </b-input-group>
      </b-form-group>

      <b-form-group label-for="sort-by-date"
                    class="mr-2 mb-0"
                    v-slot="{ ariaDescribedby }">
        <b-input-group>
          <b-form-select id="sort-by-date"
                         v-model="filteringOptions.sortBy"
                         :options="sortByOptions"
                         :aria-describedby="ariaDescribedby"
                         class="w-25">
            <template #first>
              <b-form-select-option :value="null" disabled>დალაგება თარიღით</b-form-select-option>
            </template>
          </b-form-select>
        </b-input-group>
      </b-form-group>

      <b-button variant="primary" class="" @click="filterTable">
        <feather-icon icon="FilterIcon" class="mr-50"/>
        <span class="align-middle">გაფილტვრა</span>
      </b-button>
      <b-button variant="secondary" class="" @click="clearFilters()">
        <feather-icon icon="TrashIcon" class="mr-50"/>
        <span class="align-middle">გასუფთავება</span>
      </b-button>
    </b-form-row>

    <b-col></b-col>

    <template>
      <div v-if="rows && rows.length">
        <b-table
            :id="'accounts-table' + currentPage"
            :class="className"
            :items="rows"
            :fields="columns"
            :busy="!visible"
            outlined
            small
            hover
            responsive="sm"
            fixed
            show-empty
            empty-text="No Accounts Found"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>

          <template #cell(date)="data" td-class="text-right">
            <span>{{ formatDate(data.item.date) }}</span>
          </template>

          <template #cell(actions)="item" td-class="text-right">
            <b-button variant="flat-secondary" :key="item.id" class="btn-icon" @click="editItem(item)">
              <feather-icon icon="Edit3Icon"/>
            </b-button>

            <b-button variant="flat-secondary" class="btn-icon" @click="deleteItem(item)">
              <feather-icon icon="Trash2Icon"/>
            </b-button>
          </template>

          <template #cell(name)="data">
            <div @click="rowClickHandler(data.value)" class="cursor-pointer">
              <span>{{ data.value }}</span>
            </div>
          </template>

          <template #cell(accountType)="data">
            <div @click="rowClickHandler(data.value)" class="cursor-pointer">
              <span>{{ roles.find(a => a.value === data.value) ? roles.find(a => a.value === data.value).text : '' }}</span>
            </div>
          </template>
        </b-table>
      </div>
    </template>

    <div class="card-footer-container d-flex justify-content-between align-items-center pt-2 pb-1">
      <div class="title-container d-flex align-items-center">
        <span v-if="!isLastPage" class="text-muted">ნაჩვენებია {{ perPage * currentPage }}/{{ totalCount }}</span>
        <span v-else class="text-muted">ნაჩვენებია {{ totalCount }}/{{ totalCount }}</span>
      </div>

      <b-pagination
          v-model="currentPage"
          :total-rows="totalCount"
          :per-page="perPage"
          aria-controls="index-patients-table"
          @page-click="pageChanged"
      ></b-pagination>
    </div>

  </b-card>
</template>

<script>
import {
  BCard,
  BTable,
  BButton,
  BPagination,
  BCol,
  BFormRow,
  BFormGroup,
  BInputGroup,
  BFormSelect,
  BFormSelectOption,
  BSpinner,
} from "bootstrap-vue"

export default {
  components: {
    BCard,
    BTable,
    BButton,
    BPagination,
    BCol,
    BFormRow,
    BFormGroup,
    BInputGroup,
    BFormSelect,
    BFormSelectOption,
    BSpinner,
  },
  props: ["rows", "columns", "className", "visible", "roles", "accounts_meta"],

  mounted() {
    this.totalCount = this.accounts_meta ? this.accounts_meta.total : 0
  },

  data() {
    return {
      perPage: 15,
      currentPage: 1,
      totalCount: 0,
      boxTwo: "",
      filter: null,
      filterOn: [],
      filteringOptions: {
        selectedType: null,
        selectedGroupBy: null,
        sortBy: null,
      },
      typeOptions: [
        {value: "all", text: "ყველა"},
        {value: "epidemiologist", text: "ეპიდემიოლოგები"},
        {value: "phthisiologist", text: "ფტიზიატრები"},
        {value: "admin", text: "ადმინები"},
      ],
      groupByOptions: [
        {value: "false", text: "რეგიონებად"},
        {value: "true", text: "ტუბ.კაბინეტებად"},
      ],
      sortByOptions: [
        {value: "false", text: "თარიღი ზრდადობით"},
        {value: "true", text: "თარიღი კლებადობით"},
      ]
    }
  },

  computed: {
    isLastPage() {
      return Math.floor(this.totalCount / this.perPage) === this.currentPage - 1
    },
  },

  watch: {
    accounts_meta: function (newVal) {
      this.totalCount = newVal ? newVal.total : 0
    },
  },

  methods: {
    pageChanged(bvEvent, page) {
      let filterCopy = Object.assign(this.filteringOptions)
      filterCopy["skip"] = (page - 1) * this.perPage
      this.$emit("updateTable", filterCopy);
    },

    filterTable() {
      let filterCopy = Object.assign(this.filteringOptions)
      filterCopy["skip"] = 0
      this.currentPage = 1
      this.$emit("updateTable", this.filteringOptions);
    },

    warning() {
      this.$swal({
        title: "<span class=\"font-medium-1\">დარწმუნებული ხარ რომ გსურს წაშლა?</span>",
        icon: "warning",
        html:
            "<span class=\"font-small-3\">წაშლის შემდეგ ინფორმაციის აღდგენა შეუძლებელია</span>",
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: "დიახ წაშალე",
        cancelButtonText: "გაუქმება",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      })
    },

    editItem(user) {
      this.$emit("edit", user.item);
    },

    deleteItem(user) {
      this.$emit("delete", user.item);
    },

    formatDate(date) {
      let a = [{day: "2-digit"}, {month: "2-digit"}, {year: "numeric"}];
      if (date) return this.join(new Date(date), a, ".");
      return ""
    },

    join(t, a, s) {

      function format(m) {
        let f = new Intl.DateTimeFormat("en", m);
        return f.format(t);
      }

      return a.map(format).join(s);
    },

    clearFilters() {
      this.filteringOptions.selectedType = null;
      this.filteringOptions.selectedGroupBy = null;
      this.filteringOptions.sortBy = null;
      this.$emit("updateTable", this.filteringOptions);
    }
  }
}
</script>

<style lang="scss">

.card .table tbody tr:last-child td:first-child {
  font-weight: normal !important;
}

.index-container.table-responsive-sm .table td[aria-colindex='5'] {
  text-align: right;
}

.index-container.table-responsive-sm .table th[aria-colindex='5'] div {
  display: none;
}

.btn {
  white-space: nowrap;
}

.filter-container {
  .form-group {
    width: 20%;
  }
}

@media only screen and (max-width: 1450px) {

  .filter-container {
    flex-wrap: wrap !important;

    .btn, .form-group {
      margin-top: 20px !important;
    }

    span {
      width: 100%;
    }

  }


}
</style>
